<template>
  <v-skeleton-loader
    v-if="loading"
    height="380"
    class="mb-4"
    type="card, list-item, list-item-three-line"
    boilerplate
    tile
    elevation="1"
  >
  </v-skeleton-loader>

      <!-- :loading="loading" -->
    <!-- :transition="transition" -->

  <v-card
    v-else
    align="left"
    tile
    class="mx-auto mb10"
    outlined

  >
    <v-row
      align="end"
      class="fill-height"
      dense
    >
      <v-col
        align-self="start"
        class="pt-0 pb-0"
        cols="12"
        sm="4"
      >

        <router-link :to="'/blog/post/'+uid">
          <v-img 
            width="100%"
            class="align-end minheight160@600"
            :src="media"
            lazy-src="@/assets/images/300x150.png"
          >
          </v-img>
        </router-link>
      </v-col>

      <v-col cols="12" sm="8" align-self="start">
        <v-card-title><router-link class="tdn fw400" :to="'/blog/post/'+uid"><h3 class="c-darkgray wbn">{{title}}</h3></router-link></v-card-title>

        <v-card-subtitle>
          <div class="mb5 c-gray fz12">{{date | fixDate}}</div>

          <router-link
            v-for="slug in cleanCategories"
            :key="slug.id"
            class="fOswald tdn curp" :to="'/blog/'+slug.slug"
          >
            <v-chip class="mb10 ma-1 curp" color="orange" small>{{slug.slug | capitalize}}</v-chip>
          </router-link>

        </v-card-subtitle>

        <v-card-text class="text--primary">
          <div>{{desc}}</div>
        </v-card-text>
      </v-col>
    </v-row>
  </v-card>
        <!-- </v-boilerplate> -->
</template>

<style lang="scss" scoped>
.wbn {
  word-break: normal;
}
.minheight160\@600 {
  @media all and (max-width: 600px) {
    min-height: 160px;
  }
}
</style>

<script>
import moment from 'moment';
  export default {
inject: ['theme'],
    components: {
      // VBoilerplate: {
      //   functional: true,

      //   render (h, { data, props, children }) {
      //     return h('v-skeleton-loader', {
      //       ...data,
      //       props: {
      //         // boilerplate: true,
      //         // elevation: 2,
      //         ...props,
      //       },
      //     }, children)
      //   },
      // },
    },
    props: {
      slug: { type: String},
      title: { type: String},
      desc: { type: String},
      media: { type: String},
      uid: { type: String},
      date: { type: String},
      categories: {type: Array}
    },
    filters: {
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      },
      fixDate: function (value) {
        let date;
        let f = 'MMMM Do, YYYY';
        date = moment(value).format(f);
        return date
      }
    },
    created: function() {
      this.getCategories(this.categories);
    },
    methods: {
      getCategories (catarray) {
        // let cats = [];
        let i=0;
        catarray.forEach(linkedCategories => {
          this.cleanCategories.push({id: i, slug: linkedCategories.category.slug});
          i++
        });
      }
    },
    mounted: function () {
      this.$nextTick(function () {
        // Code that will run only after the
        // entire view has been rendered
        this.loading=false
      })
    },
    data() {
      return {
        cleanCategories: [],
        loading: true,
        transition: 'fade-transition',
        transitions: [
          {
            text: 'None',
            value: undefined,
          },
          {
            text: 'Fade Transition',
            value: 'fade-transition',
          },
          {
            text: 'Scale Transition',
            value: 'scale-transition',
          },
        ],
      }
    },
  }
</script>